var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SkeletonLine } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect, useState } from 'react';
import { usePurchaseHistoryContext } from '../../hooks/useContexts';
import { getTotalSpend } from '../../api/oms/order-history';
import { PerksSpend, TotalSpend } from './index';
export var SpendingTotals = function () {
    var svocID = useThdCustomer().svocID;
    var _a = usePurchaseHistoryContext(), orderHistoryData = _a.orderHistoryData, initResultsFilter = _a.initResultsFilter, orderHistoryLoaded = _a.orderHistoryLoaded, customerType = _a.customerType;
    var _b = useState(null), totalData = _b[0], setTotalData = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var totalSpendData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 4]);
                    request = {
                        customerSpendRequest: {
                            customerAccountId: (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.customerAccountId) || svocID || '',
                            groupType: 'YEAR',
                            resultsFilter: initResultsFilter,
                        },
                    };
                    return [4 /*yield*/, getTotalSpend(request)];
                case 1:
                    response = _c.sent();
                    if (response.status === 200) {
                        setTotalData((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.customerSpendByYear) === null || _b === void 0 ? void 0 : _b[0]);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        totalSpendData();
    }, []);
    if (orderHistoryLoaded &&
        customerType === 'b2b' &&
        (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.customerAccountId)) {
        return (React.createElement("div", { "data-testid": "spendingTotals", className: "sui-flex" },
            loading ? (React.createElement("div", { className: "sui-w-60 sui-ml-1" },
                React.createElement(SkeletonLine, { variant: "heading" }))) : (React.createElement(ErrorBoundary, { name: "total-spend" },
                React.createElement(TotalSpend, __assign({}, totalData)))),
            loading ? (React.createElement("div", { className: "sui-w-60 sui-ml-1" },
                React.createElement(SkeletonLine, { variant: "heading" }))) : (React.createElement(ErrorBoundary, { name: "perks-spend" },
                React.createElement(PerksSpend, __assign({}, totalData))))));
    }
    return null;
};
